/* eslint-disable react/no-array-index-key */
import type React from "react";
import { Fragment } from "react";

import { Box } from "@mui/material";

import { SkeletonLayout } from "shared/atoms/SkeletonLayout";

import { AnswerCellContainer, GridContainer, HeaderCell, QuestionCellContainer, QuestionsHeaderCell } from "./styles";

interface HealthReportsGridSkeletonProps {
  columnCount?: number;
  rowCount?: number;
}

export const HealthReportsGridSkeleton: React.FC<HealthReportsGridSkeletonProps> = ({
  columnCount = 2,
  rowCount = 8,
}) => {
  return (
    <GridContainer columnCount={columnCount} data-testid="health-reports-grid-skeleton">
      {/* Header Row */}
      <QuestionsHeaderCell>
        <SkeletonLayout layout={{ type: "skeleton", variant: "text", width: "60%", height: "20px" }} />
      </QuestionsHeaderCell>

      {Array.from({ length: columnCount }).map((_, colIndex) => (
        <HeaderCell key={`header-${colIndex}`}>
          <Box display="flex" flexDirection="column" gap={0.5} width="100%">
            <SkeletonLayout
              layout={{
                type: "row",
                gap: 2,
                alignItems: "center",
                justifyContent: "space-between",
                children: [
                  { type: "skeleton", variant: "text", width: "50%", height: "18px" },
                  { type: "skeleton", variant: "text", width: "20%", height: "16px" },
                ],
              }}
            />
          </Box>
        </HeaderCell>
      ))}

      {/* Data Rows */}
      {Array.from({ length: rowCount }).map((_, rowIndex) => (
        <Fragment key={`row-${rowIndex}`}>
          {/* Question Cell */}
          <QuestionCellContainer rowIndex={rowIndex}>
            <SkeletonLayout
              layout={{
                type: "skeleton",
                variant: "text",
                width: rowIndex % 4 === 0 ? "80%" : "65%",
                height: "16px",
              }}
            />
          </QuestionCellContainer>

          {/* Answer Cells */}
          {Array.from({ length: columnCount }).map((_item, colIndex) => (
            <AnswerCellContainer key={`answer-${rowIndex}-${colIndex}`} rowIndex={rowIndex}>
              <SkeletonLayout
                layout={{
                  type: "skeleton",
                  variant: "text",
                  width: colIndex % 3 === 0 ? "40%" : "50%",
                  height: "16px",
                }}
              />
            </AnswerCellContainer>
          ))}
        </Fragment>
      ))}
    </GridContainer>
  );
};
